import { useQuery } from '@tanstack/react-query';
import { get } from '../../api/client';

export const useGetMembersOverview = () =>
  useQuery([], () =>
    get({
      url: 'api/v1/admin/member-overview',
    })
  );
